import React from "react";
import AboutImg1 from "../../assets/images/new/banner1 (1).jpg";
import contactImg1 from "../../assets/images/new/whyc.jpg";
import MissionImg from "../../assets/images/new/targeting.png";
import VisionImg from "../../assets/images/new/vision.png";
import contactImg2 from "../../assets/images/new/4.jpg";
import contactImg3 from "../../assets/images/new/2.jpg";
import contactImg4 from "../../assets/images/new/conatus us.png";
import contactImg5 from "../../assets/images/shapes/about-1-shape-2.png";
import contactImg6 from "../../assets/images/shapes/about-1-shape-3.png";
import { ERROR_MESSAGES } from "../../Components/GlobalErrorMessage";
import "./AboutUsPage.css";
import { useMediaQuery } from "@mui/material";
import DownloadApp from "../../Components/DownLoadApp/DownloadApp";
import Support from "../../Components/SupportComponent/Support";
import TestimonialsSection from "../../Components/TestimonialSection/Testimonial";
import batuk from "../../assets/images/new/aboutUsPageBatuk.png";
const AboutUsPage = () => {
  // const isMobileView = useMediaQuery({ maxWidth: 600 });
  return (
    <>
      <section className="page-header">
        <div className="page-header__bg"></div>
        <div className="container" >
          <h2 className="page-header__title bw-split-in-left">About Us</h2>
        </div>
      </section>
      <section className="about-us py-5">
        <div className=" d-flex flex-column " style={{ width: "100%" }}>
          {/* Main Content */}
          <div className="d-flex flex-column-reverse flex-lg-row gap-3">
            <div className="col-12 col-lg-5 order-1 order-lg-0">
              <div className="about-one__image wow fadeInLeft" data-wow-delay="100ms">
                <div className="about-one__image__one">
                  <img
                    src={batuk}
                    style={{
                      height: "400px",  // Adjust height for mobile
                      width: "100%",
                      objectFit: "contain"
                    }}
                    alt="contact"
                    className="img-fluid"
                  />
                </div>
                {/* <div className="about-one__image__two">
                  <img
                    src={batuk}
                    style={{ height: "304px", width: "262px", objectFit: "cover" }}
                    alt="contact"
                    className="img-fluid"
                  />
                </div> */}
                {/* <div className="about-one__image__shape-one">
                  <img src={contactImg4} alt="shape" className="img-fluid" />
                </div>
                <div className="about-one__image__shape-two">
                  <img src={contactImg5} alt="shape" className="img-fluid" />
                </div> */}
                {/* <div className="about-one__image__shape-three">
                  <img src={batuk} alt="shape" className="img-fluid" />
                </div> */}
              </div>
            </div>

            {/* Content Section */}
            <div className="col-12 col-lg-7 order-0 order-lg-1  ">
              <article className="about-content content">
                <h2 className="section-title">Who We Are</h2>
                <p className="text-dark">
                  Myomnamo is a one-stop digital platform dedicated to fulfilling all your spiritual and religious needs. Rooted in tradition and powered by technology, we bring you seamless access to a wide range of services. With verified Pandits and temples, a wide range of rituals and language options, authentic spiritual products with secure delivery, and personalized spiritual experiences, Myomnamo ensures a trusted and meaningful journey for every devotee.
                  <ul>
                    <li> Puja & Darshan Booking</li>
                    <li> E-Store for Spiritual Essentials</li>
                    <li> Daily Puja Services</li>
                    <li> Horoscope & Astrology Services</li>
                    <li> Puja & Darshan Booking</li>
                  </ul>
                  {/* <br /> */}
                  Let Myomnamo guide your spiritual journey with devotion, authenticity, and ease.
                </p>

                {/* <h3 className="section-subtitle">Our Mission</h3>
                <p className="text-dark">
                  We strive to make traditional worship **accessible** and
                  **effortless**...
                </p> */}

                {/* <h3 className="section-subtitle">Lorem ipsum dolor sit amet.</h3>
                <ul className="about-list">
                  <li>
                    <strong>Experienced Pandits:</strong> Handpicked professionals
                    with years of expertise.
                  </li>
                  <li>
                    <strong>Customized Rituals:</strong> Tailored puja packages for
                    every occasion.
                  </li>
                  <li>
                    <strong>Hassle-Free Booking:</strong> Effortless online scheduling
                    and consultation.
                  </li>
                  <li>
                    <strong>Authenticity & Trust:</strong> Rituals performed with
                    devotion and correctness.
                  </li>
                </ul> */}
              </article>
            </div>
          </div>

          {/* Download App  */}
          <DownloadApp />
          {/* Become a partner */}
          <Support />
          {/* Testonomial */}
          <TestimonialsSection />
        </div>
      </section>

    </>
  );
};

export default AboutUsPage;
